// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__GQ00k","container":"NotFound_container__1fusd","content":"NotFound_content__48SnK","link":"NotFound_link__D0B5M"};